export const api = {
    'jobAlertPrivate': {
        'SAVE_JOB_ALERT_PRIVATE': '/JobAlert/SaveJobAlert'
    },
    'timeline': {
        'GET_TIMELINE_DATA': '/TimeLineApi/GetTimeLineData',
        'GET_TIMELINE_VIEW_DATA': '/TimeLineApi/LoadTimelineViewData',
        'GET_NOTIFICATION_COUNT': '/TimeLineApi/LoadNotificationCount'
    },
    'candidate': {
        'GET_PROFILE_DATA': '/Candidate/GetMiniProfile',
        'SAVE_FAVORITE_JOB': '/Job/SaveFavoriteJob',
        'APPLIED_JOB': '/JobSearch/GetAppliedJobs',
        'GET_JOB_ALETS': '/JobAlert/GetJobAlert',
        'FAVROITE_JOB': '/JobSearch/GetFavoriteJobs',
        'MATCHED_JOBS': '/JobSearch/GetMatchedJobs',
        'APPLY_JOB': '/Job/ApplyForJob',
        'GET_CANDIDATE_PROFILE_DETAILS': '/Candidate/GetCandidateProfileDetails',
        'FILE_UPLOAD': '/Upload/UploadFile',
        'FILE_DOWNLOAD': '/Upload/DownloadExtCandidateAttachment',
        'GET_STATES_BY_COUNTRY': '/Candidate/GetProvinces',
        'SAVE_CANDIDATE_PROFILE': '/Candidate/SaveCandidateProfile',
        'WORKER_PERSONAL_DETAILS': '/Person/GetWorkerPersonalDetails',
        'INTERVIEW_DETAILS': '/CandidateManagement/GetInterviewDataForCandidate',
        'DELETE_ACCOUNT': '/user/forgetexternaluser',
        'CANDIDATE_EDIT_FORM_CONFIGURATION': '/Candidate/GetCandidateEditForm',
        'DOWNLOAD_PERSONAL_DATA': '/Candidate/DownloadData',
        'CANDIDATE_CREATE_FORM_CONFIGURATION': '/Candidate/GetCandidateCreationForm',
        'CANDIDATE_GET_DOCUMENT_TYPES': '/Candidate/GetCandidateDocumentTypes',
        'CANDIDATE_SAVE_DOCUMENT_TYPES': '/Candidate/SaveCandidateDocumentTypes'
    },
    'jobsearch': {
        'SEARCH_JOBS': '/search/CareerJobSearch',
        'LIST_SAVED_SEARCHES': '/search/ListUserSavedSearches',
        'GET_SORTABLE_FIELDS': '/search/getSortableFields',
        'GET_SEARCH_FACETS': '/search/searchFacets',
        'LOAD_SAVED_SEARCH': '/search/LoadSavedSearch',
        'SAVE_SEARCH': '/search/SaveSearch',
        'PUBLIC_SEARCH': '/public/CareerJobSearch',
        'PUBLIC_SEARCH_FACETS': '/public/CareerJobFacetSearch',
        'PUBLIC_GET_SORTABLE_FIELDS': '/public/CareerGetSortableFields',
        'PUBLIC_GET_LOCATIONS': '/public/GetActiveWorkLocations',
        'PUBLIC_GET_CODES': '/public/codes'
    },
    'resume': {
        'SAVE_RESUME': '/Resume/SaveExternalResumeData',
        'UPLOAD': '/Upload/UploadFile',
        'PARSE_FILE': '/Upload/GetFileBytes',
        'GET_PERSON_RESUMES': '/Resume/GetPersonResumes',
        'GET_RESUME_DATA': '/Resume/GetResumeData',
        'SAVE_EDITED_RESUME': '/Resume/SaveResumeData',
        'GET_MANGER_INFO': '/Resume/GetManagerId',
        'RESUME_OPTIONS': '/Resume/GetResumeOptions',
        'PARSE_RESUME': '/Resume/GetParsedResumeData',
        'GET_RESUME_IMPORT_FROM': '/Resume/GetResumeImportedFrom',
        'LINKEDIN_PARSE_RESUME': '/Resume/GetParsedLinkedResumeData'
    },
    'lookups': {
        'COUNTRIES_LIST': '/CountryStateCity/GetCountriesList',
        'STATES_LIST': '/CountryStateCity/GetProvinces',
        'SKILLS_LIST': '/CountryStateCity/GetAvailableSkills',
        'CERTIFICATES_LIST': '/CountryStateCity/GetAvailableCertificates',
        'SCHOOLS_LIST': '/CountryStateCity/GetAvailableSchools'
    },
    'configuration': {
        'EXTENDED_SECTION_CONFIGRATION': '/GlobalConfigurator/extendedsectionconfigurations'
    },
    'offer': {
      'UPDATE_OFFER_STATUS': '/OfferManagement/UpdateApplicationOfferStatus',
      'OFFER_DETAILS': '/OfferManagement/GetOfferDetails'
   },
    'settings': {
        'REC_SETTINGS': '/career/GetRecruitingSettings',
        'APP_SETTINGS': '/public/careers/appsettings',
        'GET_CAPTCHA_KEY': '/public/careers/getCaptchaKey',
        'GET_LOGIN_SETTINGS': '/public/careers/GetLoginSettings'
    },
    'sitemap': {
        'SITEMAP_NODES': '/Sitemap/GetSitemapNodes',
    },
    'requisition': {
        'REQUISITION_ASSESSMENT': '/Requisition/GetRequisitionAssessment',
        'REQUISITION_ASSESSMENT_SAVE': '/Requisition/SaveRequisitionAssessmentAnswer',
        'REQUISITION_ASSESSMENT_FOR_REQUISITION': '/Requisition/GetApplicationAssessmentForRequisition',
        'REQUISITION_SUBMIT_ASSESSMENT_ANSWER': '/Requisition/SubmitRequisitionAssessmentAnswers',
        'RESTRICT_CANDIDATE_REAPPLY': '/CandidateManagement/GetRestrictCandidateForReApply',
        'REQUISITION_CANDIDATEASSESSMENT': '/Requisition/GetCandidateAssessment',
        'SELF_ASSESSMENT' : '/Requisition/GetSelfAssessment'
    },
    'branding': {
        'THEME_URL': 'career.sumttheme?CSS',
        'BRANDING_LOGO': 'careerheaderlogo.sumttheme',
        'BACKGROUNG_IMAGE': 'careerbgimage.sumttheme',
        'PWA_BRANDING_LOGO': 'mobileheaderlogo.sumttheme',
        'PWA_BACKGROUND_IMAGE': 'mobilebgimage.sumttheme',
        'PWA_THEME_URL': 'career-pwa.sumttheme?CSS',
    },
    'public': {
        'i18n': {
            'GET_TRANSLATIONS': '/public/career/i18n'
        },
        'authentication': {
            'GENERATE_OTP': '/public/GenerateOTP',
            'VALIDATE_OTP': '/public/ValidateOTP',
            'SEND_TEMPORARY_CODE': '/public/SendTemporaryCode',
            'GET_COUNTRIES': '/public/GetCountries',
            'GET_CANDIDATE_CREATION_FORM': '/public/GetCandidateCreationForm',
            'GET_STATES_BY_COUNTRY': '/public/GetProvinces',
            'GET_ENABLED_LOCALES': '/public/GetEnabledLocales',
            'USER_CHECK': '/public/CheckUserIsExist',
            'GET_CITIES_BY_COUNTRY_STATE': '/public/GetCities',
            'GET_ZIPCODES_BY_COUNTRY_STATE': '/public/GetPostalCodes'
        },
        'job': {
            'GET_PUBLIC_JOB_DETAILS': '/public/GetJobDetails',
            'GET_JOB_DETAILS': '/Job/GetJobDetails'
        },
        'jobAlert': {
            'SAVE_JOB_ALERT': '/public/SaveJobAlert'
        },
        'sitemap': {
            'SITEMAP_NODES': '/public/CareerSitemap'
        }
    }
};



// WEBPACK FOOTER //
// ../UI/src/app/shared/api.ts